import modalRequestComponent from './modalRequest.component';
import RequestQuestion from './requestQuestion/requestQuestion';
import RequestForm from './requestForm/requestForm';
import sickLeaveQuestion from './sickLeaveQuestion/sickLeaveQuestion';

let modalRequestModule = angular.module('vacations-absences.modalRequest', [
  RequestQuestion,
  RequestForm,
  sickLeaveQuestion
])

.component('modalRequest', modalRequestComponent)

.name;

export default modalRequestModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/modalRequest.js